import { createSlice } from '@reduxjs/toolkit'

export const previewDRGDataSlice = createSlice({
    name: 'previewDRGData',
    initialState: {
        data: undefined,
    },
    reducers: {
        setPreviewDRGDataRedux: (state, action) => {
            state.data = action.payload;
        },
        clearPreviewDRGDataRedux: (state) => {
            state.data = undefined;
        },
    },
})

export const { setPreviewDRGDataRedux, clearPreviewDRGDataRedux } = previewDRGDataSlice.actions;

export const getPreviewDRGDataRedux = (state) => state.previewDRGData.data;

export default previewDRGDataSlice.reducer